import type { ReactNode } from "react";
import { useEffect } from "react";
import useDeviceSize from "hooks/useDeviceSize";
import { useExtendedRouter } from "hooks";
import { Box, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton } from "@chakra-ui/react";
import { useMobileMenuStore } from "stores/MobileMenuStore";
import { useTopMenuExperiment } from "modules/common/components/HeaderNav/experiment";

const SideMenu = ({ isOpen, close, content }: { isOpen: boolean; close: () => void; content: ReactNode }) => (
  <Drawer isOpen={isOpen} onClose={close}>
    <Box display={{ lg: "none" }}>
      <DrawerOverlay bg="rgba(69, 84, 115, 0.7)" />
      <DrawerContent>
        <DrawerCloseButton
          size="lg"
          color="primary.900"
          _hover={{ color: "primary.500", bg: "white" }}
          _active={{ color: "primary.700", bg: "white" }}
          rounded="full"
          mt={2}
          mr={1}
        />
        {content}
      </DrawerContent>
    </Box>
  </Drawer>
);

const SideMenuExperiment = ({ isOpen, close, content }: { isOpen: boolean; close: () => void; content: ReactNode }) => (
  <Drawer isOpen={isOpen} onClose={close} size={{ base: "full", md: "md" }}>
    <DrawerOverlay bg="rgba(69, 84, 115, 0.7)" />
    <DrawerContent h="full" boxShadow="none">
      {content}
    </DrawerContent>
  </Drawer>
);

export const MobileSideMenu = () => {
  const { isOpen, close, content } = useMobileMenuStore();
  const { isDesktop } = useDeviceSize();
  const router = useExtendedRouter();
  const experimentVariant = useTopMenuExperiment();

  useEffect(() => {
    if (isDesktop) close();
  }, [isDesktop, close]);

  useEffect(() => {
    router.events.on("beforeHistoryChange", close);

    return () => {
      router.events.off("beforeHistoryChange", close);
    };
  }, [router, close]);

  return experimentVariant ? (
    <SideMenuExperiment isOpen={isOpen} close={close} content={content} />
  ) : (
    <SideMenu isOpen={isOpen} close={close} content={content} />
  );
};
